import { AppBar, Hidden, IconButton, Toolbar, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import MenuIcon from '@mui/icons-material/Menu';
import { CognitoUser } from 'amazon-cognito-identity-js';
import React, { useEffect, useState } from 'react';
import BreadcrumbBar from '../BreadcrumbBar/BreadcrumbBar';
import logo from './logo-horiz.png';

interface HeaderProps {
    onMenuClick: () => void;
    user?: CognitoUser;
    onLogOut: () => void;
    breadcrumbRoutes: any;
}

export default function Header(props: HeaderProps) {

    const useStyles = makeStyles((theme) => ({
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            height: 200
        },
        toolbar: {
            ...theme.mixins.toolbar
        },
        title: {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        logo: {
            width: 265,
            height: 60,
            marginRight: 25
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                flex: 1,
                position: 'absolute',
                right: 25
            },
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
    }));

    const classes = useStyles();
    
    return (
        <React.Fragment>
            <AppBar id="app-bar" className={classes.appBar} position="relative">
                <Toolbar  className={classes.toolbar}>
                    <Hidden mdUp>
                        <IconButton onClick={props.onMenuClick} edge="start" className={classes.menuButton} color="inherit" aria-label="menu" size="large">
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    <img src={logo} className={classes.logo} />
                    <Hidden smDown>
                        <div className={classes.title}>
                            <Typography style={{ fontWeight: 900 }} variant="h4">
                                IDMS
                                </Typography>
                        </div>
                    </Hidden>
                </Toolbar>
                <Toolbar className={classes.toolbar}>
                    <BreadcrumbBar routes={props.breadcrumbRoutes} />
                </Toolbar>
            </AppBar>
            <Toolbar id="back-to-top-anchor" />
        </React.Fragment>

    );
}